<template>
  <b-modal
    ref="modal"
    title="File Information"
    centered
    ok-only
    ok-title="Close"
    ok-variant="outline-primary"
    auto-focus-button="ok"
    size="lg"
    @hide="closeHandler"
  >
    <div v-if="firstSelectedItem">
      <b-table :items="fileInfo" />

      <div
        v-if="hasMetaproperties"
        class="mt-3"
      >
        <b-button
          variant="outline-primary"
          class="mb-2 d-block mx-auto"
          @click="toggleMetaproperties"
        >
          {{ showMetaproperties ? 'Hide Metaproperties' : 'Show Metaproperties' }}
        </b-button>

        <MetapropertiesTable
          v-show="showMetaproperties"
          :metaproperties="firstSelectedItem.metaproperties"
        />
      </div>
    </div>
    <b-spinner v-else />
  </b-modal>
</template>

<script>
import mixinModal from './mixin';
import { createNamespacedHelpers } from 'vuex';
import {getMimeType} from "@frontend/services/file-uploader";
import MetapropertiesTable from '@frontend/components/bynder/MetapropertiesTable.vue';

const { mapGetters } = createNamespacedHelpers('fileBrowser')

export default {
  name: "FileInfoModal",
  components: {
    MetapropertiesTable
  },
  filters: {
    getFileSize(size) {
      return (size / 1000000).toFixed(2);
    },
    getFileExtension(fileUrl) {
      return fileUrl?.split('.').pop().toLowerCase();
    },
  },
  mixins: [mixinModal],
  data() {
    return {
      fileDimensions: null,
      showMetaproperties: false,
    };
  },
  computed: {
    ...mapGetters(['firstSelectedItem']),
    hasMetaproperties() {
      return this.firstSelectedItem &&
        this.firstSelectedItem.metaproperties &&
        Object.keys(this.firstSelectedItem.metaproperties).length > 0;
    },
    fileInfo () {
      return _.filter([
        { label: 'Name', value: this.firstSelectedItem.name },
        { label: 'Product Name', value: this.firstSelectedItem.product_name },
        { label: 'Description', value: this.firstSelectedItem.description },
        { label: 'ItsRapid ID', value: this.firstSelectedItem.id },
        { label: 'Asset ID', value: this.firstSelectedItem.asset_id },
        { label: 'Type', value: this.firstSelectedItem.extension
          ? this.firstSelectedItem.extension.toUpperCase()
          : this.firstSelectedItem.path
            ? this.$options.filters.getFileExtension(this.firstSelectedItem.path).toUpperCase()
            : ''
        },
        { label: 'Size', value: this.firstSelectedItem.file_size ? `${this.$options.filters.getFileSize(this.firstSelectedItem.file_size)} MB` : '' },
        { label: 'Dimensions', value: this.fileDimensions },
        { label: 'Modified', value: this.firstSelectedItem.last_updated },
        { label: 'Uploaded by', value: this.firstSelectedItem.user_name },
        { label: 'GTIN', value: this.firstSelectedItem.gtin },
        { label: 'Graphic Version Number', value: this.firstSelectedItem.graphic_version_number },
        { label: 'File Name', value: this.firstSelectedItem.file_name },
        { label: 'Image Start Date', value: this.firstSelectedItem.image_start_date },
        { label: 'Image End Date', value: this.firstSelectedItem.image_end_date },
        { label: 'Brand', value: this.firstSelectedItem.brand },
        { label: 'Sub Brand', value: this.firstSelectedItem.sub_brand },
        { label: 'Target Market', value: this.firstSelectedItem.target_market },
        { label: 'Sector', value: this.firstSelectedItem.sector },
        { label: 'Import Date', value: this.firstSelectedItem.created_at },
      ], 'value')
    },
  },
  watch: {
    firstSelectedItem() {
      if (this.firstSelectedItem && this.firstSelectedItem.type.includes('image')) {
        this.getFileDimensions();
      } else {
        this.fileDimensions = null;
      }
    }
  },
  methods: {
    getMimeType,
    isImage: (firstSelectedItem) => {
      return getMimeType({name: firstSelectedItem.path}).includes('image');
    },
    toggleMetaproperties() {
      this.showMetaproperties = !this.showMetaproperties;
    },
    async getFileDimensions() {
      const loadImage = (url) => new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = url;
      });

      const img = await loadImage(this.firstSelectedItem.path);
      this.fileDimensions = `${img.width}x${img.height}`;
    },
    closeHandler() {
      this.showMetaproperties = false;
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .table {
  margin-bottom: 0;

  thead {
    display: none;
  }

  tr:first-child td {
    border-top: none;
  }

  td:nth-child(1) {
    white-space: nowrap;
    opacity: 0.6;
  }

  td:nth-child(2) {
    word-break: break-all;
  }
}
</style>
